import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
